import { inject } from '@angular/core';
import { HttpErrorResponse, HttpEvent, HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { LoginService } from '../../core/login/login.service';
import { StateStorageService } from '../../core/auth/state-storage.service';

export const authExpiredInterceptor: HttpInterceptorFn = (request: HttpRequest<any>, next: HttpHandlerFn): Observable<HttpEvent<any>> => {
  const loginService = inject(LoginService);
  const stateStorageService = inject(StateStorageService);
  const router = inject(Router);

  if (request?.headers.get('interceptorIgnore')) {
    return next(request);
  }
  return next(request).pipe(
    catchError((err: HttpErrorResponse) => {
      if (err.status === 401) {
        loginService.logoutInClient();
        stateStorageService.storeUrl(router.routerState.snapshot.url);
        loginService.logout();
      }
      return throwError(() => err);
    })
  );
};
